import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';
import { FEE_ELETTRIC, POLIS_FEE_FIXED } from '../../App';

function CurrencyFieldInitialFixedValue({ value, data }) {
  if (typeof Number(value) !== 'number') return <>{formatCurrency(0)}</>;
  if ([...FEE_ELETTRIC, ...POLIS_FEE_FIXED].includes(data?.product_name)) {
    if (
      data?.customerType === 'customerExtra' ||
      data?.customerType === 'CLIENTE'
    ) {
      return (
        <>{formatCurrency(data.energy_contract?.contract_value_agency || 0)}</>
      );
    } else if (
      data?.customerType === 'condos' ||
      data?.customerType === 'CONDOMINIO'
    ) {
      return <>{formatCurrency(data.energy_contract?.contract_value || 0)}</>;
    }
    return <>{formatCurrency(0)}</>;
  }

  return <>{formatCurrency(value)}</>;
}

export default CurrencyFieldInitialFixedValue;
